import { request, queryString } from '../../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/settings/holiday'

export default {
  addSet (values) {
    return request(`${url}/set`, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  getTodayHoliday (date) {
    return request(`${url}/date/${date}`)
  },
  removeSet (id) {
    return request(`${url}/set/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  saveSet (id, values) {
    return request(`${url}/set/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  listYears () {
    return request(`${url}/years`)
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listItemByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}/items${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  removeImage (id, imageId) {
    return request(`${url}/${id}/images/${imageId}`, {
      method: 'DELETE',
      headers
    })
  },
  listImpactedJobByPage (page, size, filter, sorting, text) {
    return request(`${url}/job/page/${page}/size/${size}/items${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  }
}
